<template>
    <div>
        <!--account settings-->
        <div class="settings__account--profile">
            <div class="panel">
                <div class="panel__header">
                    <div class="panel__header__left">
                        Live <span>API Keys</span>
                    </div>

                    <div class="panel__header__right">
                        <button v-if="0" class="btn btn--info show-test-keys">
                            Show test keys
                        </button>
                        <button class="btn btn--primary btn--flex" @click="refresh" v-if="enableActions">
                            Request New Keys
                        </button>
                    </div>
                </div>
                <div class="panel__content panel__content--grey">
                    <div class="settings__form-container api-setting">
                        <form action="" class="form--flex-items">
                            <!--base url-->
                            <div class="form__item" v-if="env.baseUrl">
                                <label class="inline">Base <span>URL</span></label>
                                <div class="form__item__input">
                                    <input disabled="true" type="text" class="form__input" v-model="env.baseUrl" />
                                    <span class="other-options__trigger" v-clipboard="() => env.baseUrl">Copy</span>
                                </div>
                            </div>

                            <!--email address-->
                            <div class="form__item">
                                <label class="inline">Api <span>Key</span></label>
                                <div class="form__item__input">
                                    <input disabled="true" type="text" class="form__input" v-model="env.apiKey" />
                                    <span class="other-options__trigger" v-clipboard="() => env.apiKey">Copy</span>
                                </div>
                            </div>

                            <!--password-->
                            <div class="form__item" v-if="env.secretKey">
                                <label class="inline">Secret <span>Key</span></label>
                                <div class="form__item__input">
                                    <input disabled="true" type="text" class="form__input" v-model="env.secretKey" />
                                    <span class="other-options__trigger" v-clipboard="() => env.secretKey">Copy</span>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="modal fade" id="two-factor-authentication" tabindex="-1" role="dialog"
                    aria-labelledby="two-factor-authentication">
                    <!-- Modal Dialog -->
                    <div class="modal__dialog modal__dialog--xlg" role="document">
                        <!-- Modal content -->
                        <div class="modal__content">
                            <div class="modal__header">
                                <div class="modal__title">
                                    <span class="time-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                            version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px"
                                            viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;"
                                            xml:space="preserve" class="icon--sm">
                                            <g>
                                                <g>
                                                    <g>
                                                        <path
                                                            d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                                                            data-original="#000000" class="active-path"
                                                            data-old_color="#576ae6" fill="#576ae6"></path>
                                                        <path
                                                            d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                                                            data-original="#000000" class="active-path"
                                                            data-old_color="#576ae6" fill="#576ae6"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </span>
                                    Enter Two-Factor Authentication
                                </div>
                                <!-- Modal close button -->
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                        <path fill="#C0C6D8" fill-rule="nonzero"
                                            d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z">
                                        </path>
                                    </svg>
                                </button>
                            </div>
                            <!-- Modal Body -->
                            <div class="modal__body modal__body--pad">
                                <div class>
                                    <form action class="form disburse-form" @submit.prevent="submitOTP()">
                                        <div class="form__item">
                                            <label for="disburseSource" class="form__label--span form--left">
                                                Enter <span>OTP</span>
                                            </label>
                                            <div class="otp-input-group">
                                                <span class="pre-otp">{{otpPrefix}}</span>
                                                <span class="connector">-</span>
                                                <input type="text" name="otp" v-model="otp" aria-required="true"
                                                    aria-invalid="false">
                                            </div>
                                        </div>
                                        <div class="form__item disburse-form__submit">
                                            <button id="fundWallet" type="submit"
                                                class="btn btn--primary btn--block">Generate New Keys</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="panel__footer align-end">
          <div class="panel__footer__right">
            <button class="btn btn--default">Cancel</button>
            <button class="btn btn--primary">Save changes</button>
          </div>
        </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import {
    getSingleUser,
    refreshMerchantKeys
} from "../../utils/user/getUserDetails";

export default {
    created() {
        this.handleVariables(); // Fetches API-Keys from environment variables;
    },

    data() {
        return {
            env: {
                baseUrl: null,
                apiKey: null,
                secretKey: null
            },
            otpPrefix: '',
            otp: null,
            merchantId: window.localStorage.getItem("merchantId")
                ? window.localStorage.getItem("merchantId")
                : null
        };
    },
    computed: {
        enableActions: {
            get() {
                return this.$store.state.enableActions;
            },
        },
    },

    components: {},
    methods: {
        handleVariables() {
            getSingleUser(this.merchantId, false, true)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data && response.data[0]) {
                            const content = response.data[0];
                            this.env = {
                                apiKey: content.apiKey,
                                secretKey: content.secret
                            };
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        refresh() {
            let username = this.$cookies.get("userEmail");

            this.$Progress.start();
            refreshMerchantKeys(username, true)
                .then(res => {
                    // this.env = {
                    //     apiKey: data.data.data.apiKey,
                    //     secretKey: data.data.data.secret
                    // };
                    console.log(res)
                    if (res.data.twoFactorActive) { 
                        this.otpPrefix = res.data.otpPrefix ? res.data.otpPrefix : '----';
                        $("#two-factor-authentication").modal('toggle'); 
                    }
                    else if (res.data.data.apiKey) {
                        this.env = {
                            apiKey: res.data.data.apiKey,
                            secretKey: res.data.data.secret
                        };
                    }

                    this.$Progress.finish();
                })
                .catch(e => this.$Progress.finish());
        },
        submitOTP() {
            let username = this.$cookies.get("userEmail");

            this.$Progress.start();
            refreshMerchantKeys(username, false, this.otp)
                .then(res => {
                    this.otp = ""
                    this.env = {
                        apiKey: res.data.data.apiKey,
                        secretKey: res.data.data.secret
                    };
                    // console.log(res)
                    //    if(res.data.twoFactorActive){ this.$bvModal.show("bv-modal-example");}
                    $("#two-factor-authentication").modal('toggle')
                    this.$Progress.finish();
                })
                .catch(e => this.$Progress.finish());
        }
    }
};
</script>

<style lang="scss" scoped>
.panel__footer__right {
    .btn--default {
        margin-right: 8px;
    }
}

.select__icon {
    top: 12px;
}

.api-setting {

    // margin-left: -80px;
    label {
        flex-basis: 10%;
    }
}

.other-options__trigger {
    background-color: #f4f7fc;
    padding: 0 10px;
}

.form__item__input {
    position: relative;
}

</style>



// WEBPACK FOOTER //
// src/components/settings/APISettings.vue